import { axios } from '../util/axios'

const nullifierUrl = process.env.REACT_APP_NULLIFIER_URL || 'https://nullifier.olx.com.br'

const BASE_API_URL = `${nullifierUrl}/takeout`
export const startTakeout = recaptchaToken =>
  axios
    .post(
      `${BASE_API_URL}/start`,
      {},
      {
        headers: { 'X-Accounts-Takeout-Recaptcha': recaptchaToken },
        withCredentials: true,
      }
    )
    .then(response => response.status > 199 && response.status < 400)

export const fetchRequests = () =>
  axios.get(`${BASE_API_URL}/status`, {}, { withCredentials: true }).then(response => response.data)
